import { SimpleTransferOrderCreatePage } from "@/features/simple-transfer-order/pages/SimpleTransferOrderCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/simple-transfer-order/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["simple_transfer_order.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: SimpleTransferOrderCreatePage,
});
